export class QueryHelper {
  static tableSorting({ sortBy, sortDesc }) {
    const params = {
      order: [],
    };

    for (const key in sortBy) {
      params.order.push(`${sortBy[key]}:${sortDesc[key] ? "desc" : "asc"}`);
    }

    return params;
  }

  /**
   * Обьект фильтра в квери стринг
   *
   * @param {Object} data
   * @return {Object}
   */
  static filter(data) {
    const params = {};

    Object.keys(data).forEach(key => {
      if (data[key] !== null || data[key] !== undefined) {
        params[`filter[${key}]`] = data[key];
      }
    });

    return params;
  }

  /**
   * @param {number} page
   * @param {number} itemsPerPage
   * @param {number} totalPages
   * @return {{per_page: number, page: number}}
   */
  static pagination({ page, itemsPerPage }, totalPages) {
    return {
      page: page,
      per_page: itemsPerPage === -1 ? totalPages : itemsPerPage,
      limit: itemsPerPage === -1 ? totalPages : itemsPerPage,
    };
  }
}
